<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="auto"
    locale="cs-cz"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        outlined
        v-model="formatDate"
        :label="label"
        prepend-inner-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        hide-details
      />
    </template>
    <v-date-picker
      header-color="primary"
      color="secondary"
      :first-day-of-week="1"
      scrollable
      no-title
      :min="min"
      :value="value"
      @input="
        $emit('input', $event)
        menu = false
      "
    />
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    min: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    formatDate() {
      return new Date(this.value).toLocaleDateString()
    },
  },
}
</script>

<style>
.v-date-picker-header__value > .info--text {
  background-color: transparent !important;
}
</style>
